var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen bg-indigo-50",attrs:{"id":"app"}},[_c('main',{staticClass:"bg-indigo-50"},[_c('home')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }